"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavHeader = exports.LabelWrapper = exports.BackButton = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _sharedStyle = require("../../sharedStyle");
const {
  colours,
  spacing
} = _uiKit.theme;
const NavHeader = exports.NavHeader = _styledComponents.default.div.withConfig({
  displayName: "Headerstyle__NavHeader",
  componentId: "sc-1ut6h1z-0"
})(["display:flex;align-items:center;background-color:", ";position:relative;left:0;width:100vw;max-width:", "px;height:62px;border-bottom:1px solid ", ";padding:0 16px;& > div{color:", ";}"], colours.WHITE, _sharedStyle.navWidth, colours.NEUTRALS_4, colours.PRIMARY_1);
const BackButton = exports.BackButton = _styledComponents.default.button.withConfig({
  displayName: "Headerstyle__BackButton",
  componentId: "sc-1ut6h1z-1"
})(["background-color:transparent;width:16px;border:none;text-align:center;margin-right:16px;"]);
const LabelWrapper = exports.LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "Headerstyle__LabelWrapper",
  componentId: "sc-1ut6h1z-2"
})(["display:flex;align-items:center;gap:", ";& > div{color:", ";}div > span{color:", ";}"], spacing.BASE_1, colours.PRIMARY_1, colours.WHITE);